import {
  GraphQLInputObjectType,
  GraphQLNonNull,
  GraphQLID,
  GraphQLBoolean
} from 'graphql'

export interface ServerToggleMutationArgs {
  readonly input?: {
    readonly organizationID: string
    readonly id: string
    readonly enabled: boolean
  }
}

export const serverToggleMutationArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'ServerToggleMutationArgs',
      description:
        'Mutation input type for enabling/disabling protect/assess for a single server',
      fields: () => ({
        organizationID: {
          description:
            'The ID of the organization for the server being altered',
          type: new GraphQLNonNull(GraphQLID)
        },
        id: {
          description: 'ID of the server being altered',
          type: new GraphQLNonNull(GraphQLID)
        },
        enabled: {
          description:
            'The desired assess/protect status of the server being altered',
          type: new GraphQLNonNull(GraphQLBoolean)
        }
      })
    })
  }
}
